import { Controller } from "@hotwired/stimulus"

// Edit mode for the owner's routine, toggled by the native "Edit"/"Done" nav button.
// The mode is a data attribute on this element (styled with the `editing:` Tailwind
// variant), so sections redrawn by a turbo stream pick it up on their own.
export default class extends Controller {
  static targets = ["button"]
  static values = { editing: Boolean }

  initialize() {
    this.keepEditingThroughRefresh = this.keepEditingThroughRefresh.bind(this)
  }

  connect() {
    document.addEventListener("turbo:before-render", this.keepEditingThroughRefresh)
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.keepEditingThroughRefresh)
  }

  toggle() {
    this.editingValue = !this.editingValue
  }

  // A tap on the drag handle (the step number) inside a product link
  preventNavigation(event) {
    if (this.editingValue) event.preventDefault()
  }

  editingValueChanged(editing) {
    this.element.toggleAttribute("data-routine-editing", editing)
    // "Done" is a white-on-indigo-600 pill. Set before the title: the title
    // change is what re-sends the native button.
    if (editing) {
      this.buttonTarget.setAttribute("data-bridge-fill-color", "#4f46e5")
      this.buttonTarget.setAttribute("data-bridge-text-color", "#ffffff")
    } else {
      this.buttonTarget.removeAttribute("data-bridge-fill-color")
      this.buttonTarget.removeAttribute("data-bridge-text-color")
    }
    this.buttonTarget.setAttribute("data-bridge--button-title-value", editing ? "Done" : "Edit")
    this.dispatch("change", { detail: { editing } })
  }

  // A refresh (another tab changed the routine, or an edit was saved in a native
  // modal) redraws the page; stay in edit mode through it.
  keepEditingThroughRefresh(event) {
    if (!this.editingValue) return

    const next = event.detail.newBody.querySelector(`[data-controller~="${this.identifier}"]`)
    if (next?.dataset.routine === this.element.dataset.routine) {
      next.setAttribute(`data-${this.identifier}-editing-value`, "true")
    }
  }
}
